// extracted by mini-css-extract-plugin
module.exports = {"button__google":"GoogleAuth_button__google__3a5uC","google_icon":"GoogleAuth_google_icon__2KV3V","google_container":"GoogleAuth_google_container__CJFib"};